import Vue from 'vue';
import { gsap } from 'gsap';

Vue.component('word-slider-component', {
    props: ['words'],

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            currentWord: 0,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.autoplay();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        autoplay() {
            // Kill the previous tween
            gsap.killTweensOf(this.next);

            // Reset it
            gsap.delayedCall(3, this.next);
        },

        next() {
            if (this.currentWord === this.words.length - 1) {
                this.currentWord = 0;
                return;
            }

            this.currentWord += 1;
        },

        afterEnter(el) {
            this.autoplay();
        },
    },
});
